<template>
  <div class="wechat-moments-list">
    <CommonSOP :KHSOPxbc="KHSOPxbc" :KHSOPcd="KHSOPcd" :tableData="tableData" :tableHeader="tableHeader" @reGet="getData" @createSOP="createSOP" @handleDel="handleDel" @handleDetail="handleDetail" @handleData="handleData" :pageparm="pageparm"></CommonSOP>
    <CommonSOPDetail titleName="朋友圈SOP" :myType="3" @reGet="getData" :myVisiable="myVisiable" @closeDialog="closeDialog"></CommonSOPDetail>
    <DataDialog  :isLoading="isLoading" :KHSOPcd="KHSOPcd" :titleName="titleName"  :tableHeader="dataTableHeader" :tableData="dataTableData" @closeDialog="dataCloseDialog" :myVisiable="dataMyVisiable" :pageparm="dataPageparm" :myType="3" @reGet="reGet" @handleExport="handleExport"/>
    <SopDetail titleName="朋友圈SOP" :myType="3" :myVisiable="detailMyVisiable" :detaildata="detailData"  @closeDialog="closeDetailDialog"/>
  </div>
  
 </template>
 <script>
 import CommonSOPDetail from '@/views/mass/SOP/components/commonSOPDetail.vue'
 import CommonSOP from '@/views/mass/SOP/components/commonSOP.vue'
 import DataDialog from '@/views/mass/SOP/components/dataDialog.vue'
 import SopDetail from '@/views/mass/SOP/components/sopDetail.vue'
 import { getFriMomentSopList,deleteFriMomentSop,getFriMomentEmp,getFriMomentDetail } from "@/api/sop/sop.js"
 export default {
  name: "wechatMomentsSOP",
  components: {
    CommonSOP,
    CommonSOPDetail,
    DataDialog,
    SopDetail
  },
  data() {
    return {
      myVisiable: false,
      searchSelectTime: '',
      dataMyVisiable: false,
      titleName: '',      // 数据的弹框标题
      dataTableHeader: [
        {
          id: 'userName',
          label: '执行员工',
          minWidth: 100,
          align: 'center'
        },
        {
          id: 'situation',
          label: '已完成',
          minWidth: 100,
          align: 'center'
        },
        {
          id: 'publishTime',
          label: '完成时间',
          minWidth: 120,
          align: 'center'
        }
      ],
      detailData: {},
      detailMyVisiable: false,

      getDataListParams: {
        sopId: '',   
        mark: -1, // 是否完成【int】0：否  1：完成
        pageNum: 1, // 页码，不传默认为1
        pageSize: 10,  //页数，不传默认为10
      },
      dataPageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      isLoading: false,
      dataTableData: [],

      tableHeader: [
        {
          id: 'sopName',
          label: 'SOP任务',
          minWidth: 120,
          align: 'left'
        },
        {
          id: 'content',
          label: '任务内容',
          minWidth: 120,
          align: 'center'
        },
        {
          id: 'empTotal',
          label: '应完成员工数',
          minWidth: 70,
          align: 'center'
        },
        {
          id: 'empDoneTotal',
          label: '已完成员工数',
          minWidth: 70,
          align: 'center'
        },
        {
          id: 'empNoDoneTotal',
          label: '未完成员工数',
          minWidth: 70,
          align: 'center'
        },
        {
          id: 'createMessage',
          label: '创建信息',
          minWidth: 150,
          align: 'center'
        },
        {
          id: 'option',
          label: '操作',
          minWidth: 120,
          align: 'center'
        },
      ],
      getDataParams: {
        sopName: '',
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 20
      },
      tableData: [],
      sopId: '',
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      pageSizes: [20, 50, 100, 200,500], //分页条数
      KHSOPxbc: false,      // 可新建/编辑/删除
      KHSOPcd: false        // 可查看/导出数据 
    };
  },
  created() {
    this.getData(this.getDataParams)
  },
  watch: {
    btnAuthority: {
      handler(newVal,oldVal) {
        if(newVal.length > 0) {
          newVal.forEach(item => {
            if(item.pname == '客户SOP') {
              let senBtnAuthority = item.cfunBu
              if(senBtnAuthority.indexOf('KHSOPxbc') != -1) {
                this.KHSOPxbc = true
              }else {
                this.KHSOPxbc = false
              }
              if(senBtnAuthority.indexOf('KHSOPcd') != -1) {
                this.KHSOPcd = true
              }else {
                this.KHSOPcd = false
              }
            }
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority
    }
  },
  methods: {
    // 导出
    handleExport() {
      this.download('/api/sop/FriMomentSOP/exportDataFri/'+this.sopId, `朋友圈员工完成情况_${new Date().getTime()}.xlsx`,{
      },localStorage.getItem("Authorization"),1,'get')
    },
    closeDetailDialog() {
      this.detailMyVisiable = false
    },
    closeDialog(val) {
      this.myVisiable = val
    },
    dataCloseDialog(val) {
      this.dataMyVisiable = val
    },
    // 获取列表数据
    getData(params) {
      if(params == 'createNew') {
        params = this.getDataParams
        params.pageNum = 1
        params.pageSize = this.pageparm.pageSize
      }else {
        this.getDataParams = params
      }
      this.pageparm.currentPage = params.pageNum
      this.pageparm.pageSize = params.pageSize
      getFriMomentSopList(params,localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200) {
          console.log('res',res.data)
          this.tableData = res.data.records
          this.pageparm.total = res.data.total
        }
      })
      console.log('获取数据')
    },
    // 新建sop
    createSOP() {
      this.myVisiable = true
      console.log('新建')
    },
    // 点击删除按钮
    handleDel(sopId) {
      console.log('删除')
      this.$confirm('您确定删除所选内容？提交后将无法撤回？', {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: '确定',
        title: '删除',
        cancelButtonText: '取消'
      })
      .then((res) => {
        this.deleteItem(sopId)
      })
      .catch((action) => {
        // that.$message("取消删除");
        this.$message({
          message: "取消删除",
          type: 'info',
          offset: 30,
          customClass: 'info-message'
        })
      });
    },
    deleteItem(sopId) {
      deleteFriMomentSop({sopId},localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200) {
          this.$message({
            message: "删除成功！",
            type: 'success',
          })
          this.getData(this.getDataParams)
        }
      })
    },
    // 点击详情按钮
    handleDetail(sopId) {
      getFriMomentDetail(sopId,localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200) {
          this.detailData = res.data
          console.log('res.data',JSON.parse(JSON.stringify(res.data)))
          console.log('this.detailData',JSON.parse(JSON.stringify(this.detailData)))
          this.detailMyVisiable = true
        }
      })
      console.log('详情')
    },
    // 点击数据按钮
    handleData(sopId,sopName) {
      this.sopId = sopId
      this.titleName = sopName
      this.getDataListParams.pageNum = 1
      this.getDataListParams.pageSize = 10
      this.getDataListParams.mark = -1
      this.getDataListParams.sopId = sopId
      this.getDataList()
      console.log('数据')
    },
    getDataList() {
      this.isLoading = true
      if(!this.dataMyVisiable) {
        this.dataMyVisiable = true
      }
      getFriMomentEmp(this.getDataListParams,localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200) {
          this.dataTableData = res.data.records
          this.dataPageparm.total = res.data.total
          this.isLoading = false
        }else {
          this.isLoading = false
          this.$message.error('获取数据失败，请重试！')
        }
      })
    },
    // flag为true时 mark
    reGet(parm,mark) {
      if(mark != undefined) {
        this.getDataListParams.pageNum = 1
        this.getDataListParams.mark = mark
      }else {
        this.getDataListParams.pageNum = parm.currentPage
        this.getDataListParams.pageSize = parm.pageSize
      }
      this.getDataList()
    }
  }
};
 </script>
 <style lang="scss" scoped>
 .wechat-moments-list {
   height: 100%;
   width: 100%;
 }
 </style>